import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/zed/Documents/projets/Site-web-jacky/src/App.jsx");
